import { render, staticRenderFns } from "./ProvinceZones.vue?vue&type=template&id=834447a2&scoped=true&"
import script from "./ProvinceZones.vue?vue&type=script&lang=js&"
export * from "./ProvinceZones.vue?vue&type=script&lang=js&"
import style0 from "./ProvinceZones.vue?vue&type=style&index=0&id=834447a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834447a2",
  null
  
)

export default component.exports